import { render } from "./ApiIntegrationCard.vue?vue&type=template&id=754c7510&scoped=true"
import script from "./ApiIntegrationCard.vue?vue&type=script&lang=js"
export * from "./ApiIntegrationCard.vue?vue&type=script&lang=js"

import "./ApiIntegrationCard.vue?vue&type=style&index=0&id=754c7510&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754c7510"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QBadge,QCardSection,QSeparator,QCardActions});
